import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useQuery } from 'react-query';
import api from '../../../../../components/api';

export interface Category {
  'groupId': number;
  'category': string;
  'id': number;
}

function useLandingHeader(isCoffee: boolean) {
  // Navigation Handler
  const navigation = useNavigate();
  // navigate to Add Vending Machine or Coffee Machine depend on url
  const navigateToAdd = () => {
    if (isCoffee) navigation('/coffee-machine/add');
    else navigation('/vending-machine/add');
  };
  const navigateToModelConfig = () => {
    navigation('/vending-machine/model-management');
  };

  // Get Category List
  const { data: categoriesRes, isLoading: categoryListLoading } = useQuery(
    ['getAllCategories', 'vendingMachines'],
    () => api.vendingMachine.getAllCategory(),
  );
  // Manage it so can be used for React Select
  const categoryList: {value: string, label: string} [] = React.useMemo(() => {
    const resData: Category[] | undefined = categoriesRes?.data?.data;
    if (resData) {
      return resData.map((data) => ({
        value: data.id.toString(), label: data.category,
      }));
    }
    return [];
  }, [categoriesRes]);
  // Handling when category changed on React Select
  const [currentCategory, setCurrentCategory] = React.useState<{value: string, label: string}>();

  return {
    navigateToAdd,
    navigateToModelConfig,
    categoryList,
    categoryListLoading,
    currentCategory,
    setCurrentCategory,
  };
}

export default useLandingHeader;
